export default __webpack_public_path__ + "static/media/bacqueville11.2587fd59.jpg";